<template>
  <div class="breadcrumb">
    <img src="@/assets/images/icon-6.png" alt="" class="location-image" />
    <div class="text pointer" @click="goHome">首页</div>

    <template v-if="breadList.length > 1">
      <img src="@/assets/images/icon-7.png" alt="" class="back-img" />
      <div
        class="text pointer"
        :class="[type == 0 ? 'text-active' : '']"
        @click="goToTab"
      >
        {{ breadList[1].meta.breadcrumb }}
      </div>
    </template>

    <template v-if="type == 1 && breadList.length > 2">
      <img src="@/assets/images/icon-7.png" alt="" class="back-img" />
      <div class="text text-active">
        {{ breadList[2].meta.breadcrumb }}
      </div>
    </template>

    <template v-if="type == 2 && breadList.length > 2">
      <img src="@/assets/images/icon-7.png" alt="" class="back-img" />
      <div class="text text-active">
        {{ breadList[2].meta.breadcrumb }}详情
      </div>
    </template>

    <template v-if="type == 3 && breadList.length > 2">
      <img src="@/assets/images/icon-7.png" alt="" class="back-img" />
      <div class="text pointer" @click="goToCategory">
        {{ breadList[2].meta.breadcrumb }}
      </div>
      <img src="@/assets/images/icon-7.png" alt="" class="back-img" />
      <div class="text text-active">设备详情</div>
    </template>
  </div>
</template>

<script>
import { getCategoryList, getNavItemByCode } from '@/api/common/common.js'

export default {
  name: 'Breadcrumb',
  props: {
    type: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      breadList: [],
      menuList: [],
      categoryName: '',
      tabName: '',
      linkType: ''
    }
  },
  methods: {
    async getBreadcrumb() {
      const categoryId = this.$route.query?.categoryId
      const tabcode = this.$route.query?.tabcode

      if (categoryId && tabcode) {
        const params = [categoryId, tabcode]
        await this.navList(params)

        let parentNav = null
        try {
          const navRes = await getNavItemByCode(tabcode)
          if (navRes.data && navRes.data.length > 0) {
            parentNav = navRes.data[0]
          }
        } catch (e) {
          console.error(e)
        }

        this.menuList.forEach((item) => {
          if (item.categoryCode == categoryId) {
            this.categoryName =
              item.categoryName === '公司新闻' ? '媒体报道' : item.categoryName
            this.categoryName =
              this.categoryName === '实训资源'
                ? '实训资源'
                : this.categoryName
            this.linkType = item.linkType
          }
          if (item.categoryCode == tabcode) {
            this.tabName = item.categoryName
          }
        })

        let targetCode = tabcode
        let targetLinkType = this.linkType
        let targetLinkUrl = ''
        if (parentNav && parentNav.list && parentNav.list.length > 0) {
          targetCode = parentNav.list[0].categoryCode
          targetLinkType = parentNav.list[0].linkType
          targetLinkUrl = parentNav.list[0].linkUrl || ''
        }

        const home = { path: '/', meta: { breadcrumb: '首页' } }
        const baseUrl =
          '?categoryId=' +
          targetCode +
          '&linkType=' +
          targetLinkType +
          '&tabcode=' +
          tabcode +
          '&seccode=' +
          targetCode
        let tabPath = ''

        if (['123', '130'].indexOf(targetCode) != -1) {
          tabPath = '/base/introduction' + baseUrl
          if (targetLinkUrl && targetLinkUrl != 'null') {
            tabPath += '&id=' + targetLinkUrl
          }
        } else if (['202'].indexOf(targetCode) != -1) {
          tabPath = '/base/project' + baseUrl
          if (targetLinkUrl && targetLinkUrl != 'null') {
            tabPath += '&id=' + targetLinkUrl
          }
        } else if (['132'].indexOf(targetCode) != -1) {
          tabPath = '/base/faculty' + baseUrl
          if (targetLinkUrl && targetLinkUrl != 'null') {
            tabPath += '&id=' + targetLinkUrl
          }
        } else if (['134'].indexOf(targetCode) != -1) {
          tabPath = '/base/course' + baseUrl
          if (targetLinkUrl && targetLinkUrl != 'null') {
            tabPath += '&id=' + targetLinkUrl
          }
        } else if (['139', '140', '141'].indexOf(targetCode) != -1) {
          tabPath = '/collaboration' + baseUrl
          if (targetLinkUrl && targetLinkUrl != 'null') {
            tabPath += '&id=' + targetLinkUrl
          }
        } else {
          switch (targetLinkType) {
            case '1':
              tabPath = '/article' + baseUrl
              if (targetLinkUrl && targetLinkUrl != 'null') {
                tabPath += '&id=' + targetLinkUrl
              }
              break
            case '2':
              tabPath = '/singleImage' + baseUrl
              break
            case '3':
              tabPath = '/imageText' + baseUrl
              break
            case '5':
              tabPath = '/tabList' + baseUrl
              if (targetLinkUrl && targetLinkUrl != 'null') {
                tabPath += '&id=' + targetLinkUrl
              }
              break
            case '8':
              tabPath = '/coopPartner' + baseUrl
              break
            case '9':
              tabPath = '/contactUs' + baseUrl
              break
            default:
              tabPath = '/article' + baseUrl
              if (targetLinkUrl && targetLinkUrl != 'null') {
                tabPath += '&id=' + targetLinkUrl
              }
          }
        }

        const tab = {
          path: tabPath,
          meta: { breadcrumb: this.tabName }
        }

        let category = { path: '', meta: { breadcrumb: this.categoryName } }

        if (this.type == 3 && categoryId != tabcode) {
          const categoryQuery = {
            ...this.$route.query
          }
          delete categoryQuery.resourceId

          category = {
            path: {
              path: this.$route.path,
              query: categoryQuery
            },
            meta: { breadcrumb: this.categoryName }
          }

          this.breadList = [
            home,
            tab,
            category,
            { path: '', meta: { breadcrumb: '设备详情' } }
          ]
          return
        }

        this.breadList =
          categoryId == tabcode ? [home, tab] : [home, tab, category]
      } else if (this.$route.path.includes('newsDetail')) {
        const home = { path: '/', meta: { breadcrumb: '首页' } }
        const detail = { path: '', meta: { breadcrumb: '信息详情' } }
        this.breadList = [home, detail]
      }
    },
    navList(params) {
      return new Promise((resolve, reject) => {
        getCategoryList(params)
          .then((res) => {
            this.menuList = res.data
            resolve(res.data)
          })
          .catch((err) => {
            reject(err.data)
          })
      })
    },
    goHome() {
      this.$router.push('/')
    },
    goToTab() {
      if (this.breadList.length > 1 && this.breadList[1].path) {
        this.$router.push(this.breadList[1].path)
      }
    },
    goToCategory() {
      if (this.breadList.length > 2 && this.breadList[2].path) {
        this.$router.push(this.breadList[2].path)
      }
    }
  },
  created() {
    this.getBreadcrumb()
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  background: #fff;
  display: flex;
  flex-direction: row;
  height: 74px;
  line-height: 74px;
  width: 1340px;
  margin: 0 auto;
  color: #333;
  font-size: 18px;

  .back-img {
    width: 16px;
    height: 16px;
    margin: auto 8px;
  }

  .text {
    color: #333;
    margin-left: 4px;
  }

  .pointer {
    cursor: pointer;

    &:hover {
      color: #005bac;
    }
  }

  .text-active {
    color: #005bac;
  }

  .location-image {
    width: 12px;
    height: 16.286px;
    margin: auto 5px;
  }
}

.mobile-content {
  .breadcrumb {
    height: 37px;
    line-height: 37px;
    width: 345px;
    font-size: 14px;

    .text {
      margin-left: 2px;
    }

    .back-img {
      margin: auto 4px;
    }

    .location-image {
      margin: auto 3px;
      width: 10px;
      height: 12px;
      object-fit: contain;
    }
  }
}
</style>
